import { useMedia } from 'react-use';

import { desktopAndAbove } from 'style/mediaQuery';

export const useIsDesktopAndAbove = () => useMedia(desktopAndAbove);
